/** The schedule fields of a campaign, in epoch seconds. */
export type CampaignSchedule = {
  scheduled_start?: number | null;
  scheduled_stop?: number | null;
};

/** Whether a scheduled time, in epoch seconds, is after `nowSeconds`. An unset time is not. */
export function isFutureTime(seconds: number | null | undefined, nowSeconds: number): boolean {
  return seconds != null && seconds > nowSeconds;
}

/**
 * Whether the campaign has a scheduled start or stop at all, past times
 * included: archiving, deleting or stopping it removes either.
 */
export function hasSchedule(campaign: CampaignSchedule): boolean {
  return campaign.scheduled_start != null || campaign.scheduled_stop != null;
}

/** Whether the campaign is scheduled to start or stop after `nowSeconds`. */
export function hasFutureSchedule(campaign: CampaignSchedule, nowSeconds: number): boolean {
  return isFutureTime(campaign.scheduled_start, nowSeconds) || isFutureTime(campaign.scheduled_stop, nowSeconds);
}
